import { useDispatch, useSelector } from 'react-redux';
import { dashboardActions } from '../../../../../../store/slices/dashboardSlice/dashboardSlice';
import { useCallback, useState } from 'react';
import { downloadDocumentType } from '../DocumentSelect/useDocumentSelect';
import { documentExportRouteName } from './documentExportRoutes';

export const exportDocument = (
    currentDocument: string,
    selectedEstimateList?: { [key: number]: boolean },
    documentInfo?: { documentId: string; documentDate: string }
) => {
    let url = routable.getRoute(documentExportRouteName[currentDocument]);

    if (!url) return;

    const isKP = currentDocument === 'doc_kp';
    const isContract =
        currentDocument === 'doc_contract' || currentDocument === 'doc_your_contract';
    const isProposal = currentDocument === 'doc_your_proposal';

    if (isKP || isContract || isProposal) {
        const estimatesIds = Object.keys(selectedEstimateList)
            .filter((key) => selectedEstimateList[+key])
            .map((key) => +key);

        if (estimatesIds.length > 0) {
            const estimatesQuery = estimatesIds
                .map((id, index) => `${index === 0 ? '?' : '&'}estimate[]=${id}`)
                .join('');
            url += estimatesQuery;
        }

        if (isContract && documentInfo) {
            url += `&contract_number=${documentInfo.documentId}&contract_date=${documentInfo.documentDate}`;
        }
    }

    window.open(url, '_blank');
};

export const useDocumentDownloadBlock = () => {
    const dispatch = useDispatch();
    //@ts-ignore
    const { documents, is_owner } = useSelector((state) => state.dashboardReducer);
    const [isShowPopup, setIsShowPopup] = useState(false);
    const [errorStatus, setErrorStatus] = useState(false);

    const onHidePopup = useCallback(() => {
        setIsShowPopup(false);
    }, []);

    const onShowDocumentInfo = useCallback(() => {
        setErrorStatus(false);
        if (
            !documents.tariff_access[documents.currentDocument] &&
            documents.currentDocument !== null
        ) {
            if (is_owner) {
                //@ts-ignore
                const url = routable.getRoute('openChangeTariff');
                //@ts-ignore
                $.modalable('open', {
                    url: url,
                });
            } else {
                setIsShowPopup(!isShowPopup);
            }
        } else {
            dispatch(dashboardActions.onModalMode(documents.currentDocument));
            const currentDocument = documents.currentDocument;
            if (!currentDocument) {
                setErrorStatus(true);
            }
            if (downloadDocumentType.includes(currentDocument)) {
                exportDocument(currentDocument);
            } else {
                dispatch(dashboardActions.onModalMode(currentDocument));
            }
        }
    }, [documents.currentDocument, dispatch]);
    return { onShowDocumentInfo, isShowPopup, onHidePopup, errorStatus, setErrorStatus };
};
